import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import { RootState } from "@/store/types";

import qr from '@/store/modules/qr'

Vue.use(Vuex);

export const store: StoreOptions<RootState> = {
  modules: {
    qr
  },
};

export default new Vuex.Store<RootState>(store);
